import * as React from "react";
import { Alert, Box, Button, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Paper, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";

export default function GapUploadPanel({ files, onFileChange, onRemove }) {
    return (
        <Box sx={{ width: "100%", maxWidth: 760, mx: "auto", mb: 1.5 }}>
            <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px dashed", borderColor: "divider" }}>
                <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>Upload File</Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
                    Upload a file to analyze (max 1 file, 1MB limit). Supports PDF, Word, Excel, and text files.
                </Typography>
                <input
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv"
                    style={{ display: "none" }}
                    id="gap-file-upload"
                    type="file"
                    onChange={onFileChange}
                />
                <label htmlFor="gap-file-upload">
                    <Button variant="outlined" component="span" startIcon={<AttachFileIcon />} fullWidth>
                        {files.length > 0 ? "Change File" : "Choose File"}
                    </Button>
                </label>
                {files.length > 0 && (
                    <List dense sx={{ mt: 1.5, bgcolor: "background.default", borderRadius: 1 }}>
                        {files.map((file) => (
                            <ListItem key={file.name} sx={{ py: 0.5, px: 1 }}>
                                <AttachFileIcon sx={{ mr: 1, fontSize: 18, color: "text.secondary" }} />
                                <ListItemText
                                    primary={file.name}
                                    secondary={`${(file.size / 1024).toFixed(2)} KB`}
                                    primaryTypographyProps={{ variant: "body2" }}
                                    secondaryTypographyProps={{ variant: "caption" }}
                                />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="delete" size="small" onClick={onRemove}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                )}
            </Paper>
            {files.length === 0 && (
                <Alert severity="warning" sx={{ mt: 1 }}>Please upload a file to perform Gap and Analysis</Alert>
            )}
        </Box>
    );
}
